import { render, staticRenderFns } from "./recentWork.vue?vue&type=template&id=030c1080&scoped=true&"
import script from "./recentWork.vue?vue&type=script&lang=js&"
export * from "./recentWork.vue?vue&type=script&lang=js&"
import style0 from "./recentWork.vue?vue&type=style&index=0&id=030c1080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c1080",
  null
  
)

export default component.exports